/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PartSelector_proposal$ref = any;
export type ProposalStatus = "ACCEPTED" | "DRAFT" | "DRAFT_WITH_CONFLICTS" | "ESCALATED" | "PROPOSED_OUTSIDE_MEETING";
import type { FragmentReference } from "relay-runtime";
declare export opaque type EditorFooter_proposal$ref: FragmentReference;
declare export opaque type EditorFooter_proposal$fragmentType: EditorFooter_proposal$ref;
export type EditorFooter_proposal = {|
  +id: string,
  +status: ProposalStatus,
  +$fragmentRefs: PartSelector_proposal$ref,
  +$refType: EditorFooter_proposal$ref,
|};
export type EditorFooter_proposal$data = EditorFooter_proposal;
export type EditorFooter_proposal$key = {
  +$data?: EditorFooter_proposal$data,
  +$fragmentRefs: EditorFooter_proposal$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditorFooter_proposal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PartSelector_proposal"
    }
  ],
  "type": "Proposal",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '81566f3aadb127cd3a05ef2f7771197a';

module.exports = node;
